// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
// const base = 'producao';
const base = 'homologacao';
export const environment = {
  production: false,
  
  // base_url_api:'http://127.0.0.1:8000/', 
  // base_url_api:'http://api.natureza51.local/',
  // base_url_api: 'https://130.100.10.201:8180/natureza51/mrn-natureza-51/public/',
  base_url_api: `https://apps2.mrn.com.br:8180/backend_natureza51/${base}/public/`, // MRN --
  // base_url_api: `https://apps.mrn.com.br/backend_natureza51/public/`, // MRN PRODUCAO NOVA  
  // base_url_api:'http://192.168.1.31/mrn-natureza-51/public/',
  // base_url_api:'http://127.0.0.1/mrn-natureza-51/mrn-natureza-51/public/',
  // base_url_api:'https://api2.mrn.com.br:8180/backend_natureza51/public/', //MRN PRODUÇÂO
  // base_url_api:'http://localhost:8080/natureza51/public', //ZEUS
  // base_url_api:'http://api.natureza51.local/',
  home_route:'natureza51/dashboard-gestor', 
  login_route:'insti/login',
  reset_password_route:'insti/reset-password', 
  logout_route:'insti/logout',
  main_menu_id:1,


  // export_route:'http://127.0.0.1/mrn-natureza-51/mrn-natureza-51/public//downloadExcel',//Minha máquina pelo localhost
  // export_route:'http://127.0.0.1:8000/downloadExcel',//Minha máquina pelo localhost
  // export_route:'http://127.0.0.1/mrn-natureza-51/mrn-natureza-51/public/downloadExcel',//maquina matheus
  // export_route:'https://apps2.mrn.com.br:8180/natureza51/mrn-natureza-51/public/downloadExcel',//Base MRN HOMOLOGAÇÃO
  // export_route:'https://apps.mrn.com.br/backend_natureza51/public/downloadExcel',//Base MRN PRODUÇÃO
  export_route:`https://apps2.mrn.com.br:8180/backend_natureza51/${base}/public/downloadExcel`,//Base MRN --
  // export_route:'https://apps2.mrn.com.br:8180/natureza51/mrn-natureza-51/public/downloadExcel',//Base MRN
  // export_route:'https://api2.mrn.com.br:8180/backend_natureza51/public/downloadExcel',//Base MRN Produção
  // export_route:'http://localhost:8080/natureza51/public/downloadExcel', //ZEUS

};
